// assets
import { IconBrandChrome, IconHelp, IconWallet, IconBuildingBank } from '@tabler/icons-react';
import AccountBalanceOutlinedIcon from '@mui/icons-material/AccountBalanceOutlined';

// constant
const icons = { IconBrandChrome, IconHelp, IconWallet, IconBuildingBank };

// ==============================|| SAMPLE PAGE & DOCUMENTATION MENU ITEMS ||============================== //

const other = {
    id: 'wallet-account',
    type: 'group',
    children: [
        {
            id: 'wallet',
            title: 'کیف پول',
            type: 'item',
            url: '/wallet',
            icon: icons.IconWallet
        },
        {
            id: 'account',
            title: 'شماره حساب‌ها',
            type: 'item',
            url: '/account',
            icon: icons.IconBuildingBank
        }
    ]
};

export default other;
